import * as React from "react"

import { UploadIcon } from "lucide-react"

import { cn } from "@/lib/utils"

interface Props {
  onSelect: (files: FileList) => void
}

export function DocumentSelectionBox({ onSelect }: Props) {
  const fileInputRef = React.useRef<HTMLInputElement | null>(null)
  const [cardBorder, setCardBorder] = React.useState<boolean>(false)

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onSelect(e.target.files)
    }
  }

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setCardBorder(false)
    onSelect(e.dataTransfer.files)
  }

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setCardBorder(true)
  }

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setCardBorder(false)
  }

  return (
    <div
      className={cn(
        "bg-background flex w-full flex-col items-center gap-2 rounded-lg",
        "cursor-pointer border border-transparent p-5",
        "hover:border-primary hover:border",
        cardBorder && "border-primary border",
      )}
      onClick={() => fileInputRef.current?.click()}
      onDrop={handleFileDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={(e) => {
        e.preventDefault()
      }}
    >
      <input
        ref={fileInputRef}
        type="file"
        hidden
        onChange={onInputChange}
        multiple
      />
      <UploadIcon className="h-5 w-5" />
      <p className="text-sm">Drag and drop / Upload your application here</p>
      <p className="text-sm">.pdf, .xlsx, .jpg or .png</p>
    </div>
  )
}
